import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DesktopSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DesktopSVG;
